import { Component } from "./component";
import { IMessagingService } from "../services/interfaces/messagingService";
import { waitForElement } from "../utils";

class ContactUsComponent extends Component {

    private liveChatCard: HTMLElement;
    private openLiveChatLink: HTMLElement;
    private liveChatContainer: HTMLElement;
    private liveChatImage: HTMLElement;
    private liveChatAvailable: HTMLElement;
        
    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        this.liveChatContainer = document.querySelector<HTMLElement>(".js-livechat-container");
        this.liveChatCard = componentEl.querySelector<HTMLElement>(".js-livechat-card");
        this.liveChatAvailable = componentEl.querySelector<HTMLElement>(".js-live-chat-available");
        this.openLiveChatLink = componentEl.querySelector<HTMLElement>(".js-livechat-link");

        this.init();
    }

    private async init() {

        // Check if Live Chat container exists on the page
        if (this.liveChatContainer != null)
        {
            // Disable Live Chat card & link as it won't be loaded initially
            this.disableLiveChatLaunch();

            // Wait for Live Chat to load then enable card and link
            waitForElement('.LPMimage').then((elm) => {
                this.liveChatImage  = document.querySelector<HTMLElement>(".LPMimage");
                this.enableLiveChatLaunch();
            });
        }
    }

    private disableLiveChatLaunch() {
        this.openLiveChatLink.setAttribute("aria-disabled", "true");
        this.openLiveChatLink.addEventListener("click", (event) => {
            event.preventDefault();
        });

        this.liveChatCard?.classList.remove("card-component--clickable");
        this.liveChatCard?.classList.remove("js-card-clickable");

        this.liveChatCard?.addEventListener("click", (event) => {
            event.preventDefault();
        });

        this.liveChatAvailable.innerText = "";
     }

     private enableLiveChatLaunch() {
        this.openLiveChatLink.setAttribute("aria-disabled", "false");
        this.openLiveChatLink.addEventListener("click", (event) => {
            event.preventDefault();

            if (this.liveChatImage) {
                this.liveChatImage.click()
            } else {
              console.log("Live Chat not available");
            }
            return false;
        });
        this.liveChatAvailable.innerText = "Live chat is available";

        this.liveChatCard?.classList.add("card-component--clickable");

        this.liveChatCard?.addEventListener("click", (event) => {
            event.preventDefault();
            if (this.liveChatImage) {
                this.liveChatImage.click()
            } else {
              console.log("Live Chat not available");
            }
            return false;
        });         
    }
}

export { ContactUsComponent };